/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  SET_QNAS (state, qnas) {
    state.qnas = qnas
  },
  SET_QNASP (state, qnasp) {
    state.qnasp = qnasp
  },
  REMOVE_RECORD (state, itemId) {
    const qnaIndex = state.qnas.findIndex((u) => u.Email === itemId)
    state.qnas.splice(qnaIndex, 1)
  }
}
